import { gql } from '@apollo/client';
import { NewsroomSetupContextProvider } from '../../contexts/NewsroomSetupContext';
import { useAiGeneratedNewsroomSettingsQuery } from '../../generated/hooks';
import type { PressroomGoLiveFragment, UserBaseInfoFragment } from '../../generated/types';
import NewsroomSetupModal from './NewsroomSetupModal';

gql`
  fragment AiNewsroomSettings on NewsroomSettings {
    id
    tagline(aiGenerate: true)
    companyDescription(aiGenerate: true)
  }
  query AiGeneratedNewsroomSettings($pressroomId: ID!) {
    pressroom(id: $pressroomId) {
      id
      newsroomSettings {
        id
        ...AiNewsroomSettings
      }
    }
  }
`;

const NewsroomSetup = ({
  user,
  pressroom,
  showReadyToGoLive,
}: {
  user: UserBaseInfoFragment;
  pressroom: PressroomGoLiveFragment;
  showReadyToGoLive: boolean;
}) => {
  const { data } = useAiGeneratedNewsroomSettingsQuery({
    variables: { pressroomId: pressroom.id },
  });

  return (
    <NewsroomSetupContextProvider
      showReadyToGoLive={showReadyToGoLive}
      pressroom={pressroom}
      user={user}
      aiGeneratedNewsroomSettings={data?.pressroom?.newsroomSettings ?? undefined}
    >
      <NewsroomSetupModal />
    </NewsroomSetupContextProvider>
  );
};

export default NewsroomSetup;
